module.exports = __webpack_public_path__ + "img/ebook-hero-thumb1.9535c3f7.png";